import { useNavigate, useLocation } from "react-router-dom";
import s from "./styles.module.scss";
import { ReactComponent as CalendarIcon } from "../../assets/calendaricon.svg";
import { ReactComponent as CoursesIcon } from "../../assets/courses.svg";
import { ReactComponent as ConsoleIcon } from "../../assets/console.svg";
import { ReactComponent as UploadIcon } from "../../assets/uploadSidebar.svg";
import { useTour } from "../../contexts/tour-context";

const MobileTourNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isTourActive, isMobile } = useTour();

  // Only render when tour is active on mobile
  if (!isTourActive || !isMobile) {
    return null;
  }

  // Navigation tabs - ordered to match tour step sequence
  const tabs = [
    { id: "upload", label: "Upload", icon: UploadIcon, path: "/upload" },
    { id: "calendar", label: "Calendar", icon: CalendarIcon, path: "/calendar" },
    { id: "courses", label: "Courses", icon: CoursesIcon, path: "/courses" },
    { id: "console", label: "Console", icon: ConsoleIcon, path: "/console" },
  ];

  return (
    <nav className={s.mobileTourNav}>
      <div className={s.navLabel}>Tour Navigation</div>
      <div className={s.navItems}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = pathname === tab.path;

          return (
            <button
              key={tab.id}
              className={`${s.navItem} ${isActive ? s.active : ""}`}
              onClick={() => navigate(tab.path)}
              data-tour={`nav-${tab.id}`}
            >
              <Icon className={s.navIcon} />
              <span className={s.navText}>{tab.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileTourNav;
